import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const AdminTemplateUploadsReport = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [months, setMonths] = useState([]);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const tableRows = useMemo(() => {
    return months.map((month, index) => {
      const values = rows.map((row) => Number(row.months?.[index] || 0));
      const total = values.reduce((sum, value) => sum + value, 0);

      return {
        month,
        values,
        total,
      };
    });
  }, [months, rows]);

  const annualTotals = useMemo(() => {
    const values = rows.map((row) => Number(row.total || 0));
    const total = values.reduce((sum, value) => sum + value, 0);

    return { values, total };
  }, [rows]);

  const loadReport = () => {
    setLoading(true);
    setError('');

    axios.get('/api/administrator/templates/uploads-report', { params: { year } })
      .then((response) => {
        const data = response.data || {};
        setMonths(data.months || []);
        setRows(data.rows || []);
      })
      .catch((err) => {
        setError(err?.response?.data?.message || 'No fue posible cargar el reporte de plantillas.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadReport();
  }, [year]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start flex-wrap mb-5">
        <div className="mb-3 mb-md-0">
          <h3 className="mb-2">Uso general de plantillas automáticas</h3>
          <p className="text-muted mb-0">
            Conteo mensual global por fecha de carga del archivo. Cada person_document cuenta una sola vez.
          </p>
        </div>
        <div className="d-flex align-items-center">
          <button type="button" className="btn btn-light-primary mr-2" onClick={() => setYear((prev) => prev - 1)} disabled={loading}>
            Año anterior
          </button>
          <span className="font-weight-bold px-3 py-2 border rounded">{year}</span>
          <button type="button" className="btn btn-light-primary ml-2" onClick={() => setYear((prev) => prev + 1)} disabled={loading || year >= currentYear}>
            Año siguiente
          </button>
        </div>
      </div>

      {error ? <div className="alert alert-danger">{error}</div> : null}

      {loading ? (
        <div className="text-muted">Cargando reporte...</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-hover">
            <thead>
              <tr>
                <th style={{ minWidth: '140px' }}>Mes</th>
                {rows.map((row) => (
                  <th className="text-right" style={{ minWidth: '180px' }} key={row.key}>{row.title}</th>
                ))}
                <th className="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {tableRows.length > 0 ? tableRows.map((row) => (
                <tr key={row.month.number}>
                  <td className="font-weight-bold">{row.month.label}</td>
                  {row.values.map((value, index) => (
                    <td className="text-right" key={`${row.month.number}-${rows[index]?.key || index}`}>{value}</td>
                  ))}
                  <td className="text-right font-weight-bold">{row.total}</td>
                </tr>
              )) : (
                <tr>
                  <td className="text-center text-muted" colSpan={rows.length + 2}>
                    No hay datos para mostrar.
                  </td>
                </tr>
              )}
            </tbody>
            {rows.length > 0 ? (
              <tfoot>
                <tr className="font-weight-bold">
                  <td>Total anual</td>
                  {annualTotals.values.map((value, index) => (
                    <td className="text-right" key={`total-${rows[index]?.key || index}`}>{value}</td>
                  ))}
                  <td className="text-right">{annualTotals.total}</td>
                </tr>
              </tfoot>
            ) : null}
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminTemplateUploadsReport;
